import React, { useContext } from "react";
import { View, Text, StyleSheet, TouchableOpacity, Platform } from "react-native";

import { find } from "lodash";
import { navigate, nowUserTz } from "../../../../helpers/utils";

import JournalContext from "../JournalContext";
import ImageComponent from "../../common/ImageComponent";
import appStyles from "../../../appStyles";

function TimeslotAutoTrackButton({ undoId, journalContext }) {
  const { controller } = journalContext || {};

  /* to remove if alternative works ok
  const autoreviewData = find(
    controller.state.cards_v2,
    (c) => c.type === "autoreview",
  );
  const undoId = autoreviewData.undo_chunk_id;
  */

  const undoAutoTrackedEntries = () => {
    const action = {
      action: "undo",
      source: "autotrack",
      id: undoId,
    };

    controller.tracking.track("Undo AutoTrack");
    console.log("Undo Autotrack");
    controller.cardActionWithCallback(action, (data) => {
      navigate(controller, "rn:home_card");
    });
  };

  /*   const confirmAutoTrackedEntries = () => {
    const undoId = autoreviewData.undo_chunk_id;
    const action = {
      action: "confirm",
      source: "autotrack",
      id: undoId,
    };

    controller.tracking.track("Confirm AutoTrack");
    controller.cardActionWithCallback(action, (data) => {
      navigate(controller, "rn:home_card");
    });
  }; */

  /*   const saveAutoreview = () => {
    const autoReviewTimeslots = selectedTimeslots.filter(
      (t) => !!t.id_autoreview,
    );

    const ts = autoReviewTimeslots.pop();
    if (!ts) return;

    const endDateTime = nowUserTz(controller).format("YYYY-MM-DD HH:mm:ss");

    controller.cardActionWithCallback(
      {
        action: "save",
        target: "autoreview",
        id_chunk: ts.id,
        end_time: endDateTime,
      },
      () => {
        navigate(controller, "rn:home_card");
      },
    );
  }; */

  return (
    <>
      {showAutoTrack ? (
        <View
          style={[
            appStyles.timeslot,
            { display: "flex", flexDirection: "row" },
          ]}
        >
          <TouchableOpacity
            onPress={undoAutoTrackedEntries}
            style={styles.button}
          >
            <ImageComponent
              image={require("../../../../assets/home/Rectangle.png")}
              style={styles.imageBg}
            />
            <Text style={styles.buttonText}>Undo Auto-Track</Text>
          </TouchableOpacity>
        </View>
      ) : null}
    </>
  );
}

export default TimeslotAutoTrackButton;

const styles = StyleSheet.create({
  button: {
    width: "100%",
    height: 40,
    marginTop: 2,
    borderRadius: 25,
    shadowOpacity: 0.25,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowColor: "#000",
    shadowRadius: 4,
    elevation: 5,
    marginBottom: 5,
    overflow: "hidden",
  },
  buttonText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 40,
    letterSpacing: 1,
    color: "#FFF",
    textAlign: "center",
    zIndex: 2,
  },
  imageBg: {
    maxWidth: "100%",
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  },
});
